import { createFileRoute } from "@tanstack/react-router";

import { SkillsPage } from "../../../workspaces/work-atlas/pages/SkillsPage";

export const Route = createFileRoute("/_console/p/$org/$project/work-atlas/skills")({
  component: SkillsPage,
});
